var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacyIncognito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.85 44.85A25.175 25.175 0 0 1 30 50C12.5 50 2.5 30 2.5 30a46.124 46.124 0 0 1 12.65-14.85m9.6-4.55A22.798 22.798 0 0 1 30 10c17.5 0 27.5 20 27.5 20a46.257 46.257 0 0 1-5.4 7.975M35.3 35.3a7.5 7.5 0 1 1-10.6-10.6M2.5 2.5l55 55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyIncognito);
export default __webpack_public_path__ + "static/media/privacy-incognito.3b55d96dce4d9bdd9a513086778b43d9.svg";
export { ForwardRef as ReactComponent };